<template>
  <div class="jotform-embed">
    <iframe
      :id="`JotFormIFrame-${id}`"
      :src="embedUrl"
      allow="geolocation; microphone; camera; fullscreen"
      allowtransparency="true"
      frameborder="0"
      scrolling="no"
      class="jotform-embed__iframe"
    />
  </div>
</template>

<script setup lang="ts">
declare global {
  interface Window {
    jotformEmbedHandler: (selector: string, url: string) => void
  }
}

interface Props {
  id: number;
  embedUrl: string;
}

const props = defineProps<Props>()

useHead(() => ({
  script: [
    {
      src: 'https://formulieren.avrotros.nl/s/umd/latest/for-form-embed-handler.js',
      async: true,
      defer: true,
      tagPosition: 'bodyClose',
      onload: () => {
        if (window.jotformEmbedHandler === undefined) {
          throw new Error('Jotform embed handler not loaded')
        }

        window.jotformEmbedHandler(`iframe[id='JotFormIFrame-${props.id}']`, 'https://formulieren.avrotros.nl/')
      }
    }
  ]
}))
</script>

<style scoped lang="postcss">
.jotform-embed {
  width: 100%;
  overflow: clip;
  border-radius: 20px;

  &__iframe {
    height: 120px;
    width: 100%;
    border-style: none;
  }
}
</style>
